import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { firestore } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

function ApplicationPage() {
  const [billsList, setBillsList] = useState([]);

  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "bills"));
      const bills = [];
      querySnapshot.forEach((doc) => {
        bills.push({ id: doc.id, ...doc.data() }); // ID'yi ekledik
      });
      setBillsList(bills);
    } catch (error) {
      console.error("Faturalar alınırken hata oluştu:", error);
    }
  };

  return (
    <div>
      <h2>Başvurular</h2>
      <table>
        <thead>
          <tr>
            <th>Öğrenci Adı</th>
            <th>Elektrik Tüketimi</th>
            <th>Su Tüketimi</th>
            <th>Elektrik Faturası</th>
            <th>Su Faturası</th>
          </tr>
        </thead>
        <tbody>
          {billsList.map((bill) => (
            <tr key={bill.id}>
              <Link to={`/upload/${bill.id}?name=${encodeURIComponent(bill.studentName)}`}>
  {bill.studentName}
</Link>


              <td>{bill.decemberElectricBill}</td>
              <td>{bill.decemberWaterBill}</td>
              <td>
                {bill.decemberElectricBillUrl ? (
                  <a href={bill.decemberElectricBillUrl} target="_blank" rel="noreferrer">
                    Görüntüle
                  </a>
                ) : (
                  "Yok"
                )}
              </td>
              <td>
                {bill.decemberWaterBillUrl ? (
                  <a href={bill.decemberWaterBillUrl} target="_blank" rel="noreferrer">
                    Görüntüle
                  </a>
                ) : (
                  "Yok"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ApplicationPage;
